{
	"optionsOrders": {
		"activeOrders": {
			"filled": "Executed",
			"open": "Open",
			"canceled": "Canceled",
			"OPEXP": "Expired",
			"OPEXC": "Exercises",
			"OPASN": "Assigned"
		},
		"optionsType": {
			"orders": "Orders",
			"postTrading": "Post-trading"
		}
	}
}
